<template>
    <v-main>
        <v-container v-if="loading">
            <cardWait />
        </v-container>
        <v-container fluid class="relative ma-2" v-if="!loading">
            <v-row cols="12">
                <v-col cols="12" class="pr-6">
                    <tableVirtualConversationRuns :conversation_id="thread_id" :run_id="run_id"/>
                </v-col>
            </v-row>
        </v-container>
        <navbar title="ARES - OpenAI" type="openai" :home="true" @actionClick="actionClick" />
    </v-main>
</template>

<script>
    import navbar from '@/components/ui/navbars/navbar.vue';

    import cardWait from '@/components/syst/openai/cardWait.vue';
    import tableVirtualConversationRuns from '@/components/syst/openai/tableVirtualConversationRuns.vue';

    export default {        
        components: {
            navbar,
            cardWait,
            tableVirtualConversationRuns,
        },
        props: {
            thread_id: {
                type: String,
                required: true,
            },
            run_id: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                loading: false,
            }
        },
        mounted() {
        },
        methods: {
            // Dummy callback for navBar
            actionClick() {

            },           
        },
    }
</script>

<style scoped>
</style>
